import { FC, memo, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Dropdown from 'antd/lib/dropdown/dropdown';
import { MenuProps } from 'antd/lib/menu';
import Switch from 'antd/lib/switch';

import UserStatus from 'components/Header/UserStatus';
import { isAdminSelector, userSettingsByKeySelector } from 'store/selectors/userSelectors';
import { logoutAction, setThemeAction } from 'store/actions/userActions';
import useModal from 'hooks/useModal';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { EModalsNames } from 'modals/constants';
import { STORAGE_KEYS } from 'utils/constants/constants';
import { THEME } from 'utils/constants/wordsConstants';
import { EThemes } from 'types/commonEnums';
import { DarkModeIcn, LogoutIcn, UserIcn } from 'utils/icons';

const HeaderActions: FC = () => {
  const dispatch = useDispatch();
  const theme = useTypedSelector((state) => userSettingsByKeySelector({ key: THEME, ...state }));
  const isAdmin = useTypedSelector(isAdminSelector);
  const setModal = useModal();
  const newTheme = theme === EThemes.Dark ? EThemes.Light : EThemes.Dark;

  const items: MenuProps['items'] = useMemo(
    () => [
      ...(isAdmin && [
        {
          key: 'showAsUser',
          label: 'Show as user',
          icon: <UserIcn />,
          onClick: () => setModal({ modalName: EModalsNames.ShowAsUser }),
        },
      ] || []),
      {
        key: 'darkMode',
        label: <>Dark Mode <Switch className="ml-2" checked={theme === EThemes.Dark} /></>,
        icon: <DarkModeIcn />,
        onClick: () => {
          localStorage.setItem(STORAGE_KEYS.theme, newTheme);
          dispatch(setThemeAction({ theme: newTheme }));
        },
      },
      { key: 'logOut', label: 'Log out', icon: <LogoutIcn />, onClick: () => dispatch(logoutAction(true)) },
    ],
    [newTheme],
  );

  return (
    <div className="flex items-center gap-x-2.5">
      <UserStatus />
      {/* <span className="beamerTrigger pointer h-24"><BeamerIcn /></span>*/}
      {/* <span className="h-24 clickable"><HelpIcn /></span>*/}
      <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']} destroyPopupOnHide>
        <span><UserIcn className="clickable" /></span>
      </Dropdown>
    </div>
  );
};

export default memo(HeaderActions);
